import { tv } from '@/lib/tv';

export const textVariants = tv({
  variants: {
    variant: {
      large: 'text-lg leading-7 tracking-[-0.02px]',
      body: 'text-sm leading-5 font-medium',
      'body-semibold': 'text-sm leading-5 font-medium',
      label: 'text-sm leading-5 font-medium',
      'label-semibold': 'text-sm leading-5 font-medium',
      caption: 'text-[12px] leading-[18px] font-medium tracking-[-0.02px]',
      'caption-semibold':
        'text-[12px] leading-[18px] font-medium tracking-[-0.02px]',

      h1: 'text-3xl leading-9 font-serif',
      h2: 'text-[26px] leading-8 font-serif',
      h3: 'text-xl leading-7 font-serif',
      h4: 'text-lg leading-[26px] font-medium',
      h5: 'text-base leading-6 font-medium',
      h6: 'text-sm leading-5 font-medium',

      p: 'text-sm leading-5 font-medium',
      span: '',
      div: '',
      a: 'text-sm leading-5 font-medium',
      li: 'text-sm leading-5 font-medium',
      blockquote: 'text-sm leading-6 border-l-2 border-border pl-6',
      code: 'text-xs leading-5 font-mono',
    },
    color: {
      primary: 'text-text-primary',
      secondary: 'text-text-secondary',
      tertiary: 'text-text-tertiary',
      muted: 'text-text-secondary/40',
      brand: 'text-text-brand',
      destructive: 'text-text-negative',
      inherit: 'text-inherit',
      'on-color': 'text-text-on-colour',
    },
    weight: {
      regular: 'font-normal',
      medium: 'font-medium',
    },
    font: {
      serif: 'font-serif',
    },
    fontNumeric: {
      tabular: 'tabular-nums font-mono',
      oldstyle: 'oldstyle-nums',
      lining: 'lining-nums',
      proportional: 'proportional-nums',
    },
    noLineHeight: {
      true: 'leading-none',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
      justify: 'text-justify',
    },
    truncate: {
      'single-line': 'truncate',
      'two-lines': 'line-clamp-2',
      'three-lines': 'line-clamp-3',
    },
    wrap: {
      balance: 'text-balance',
      pretty: 'text-pretty',
    },
  },
  defaultVariants: {
    variant: 'label',
    color: 'primary',
  },
});
